import AddressDisplay from 'common/components/address/AddressDisplay';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';

const Address = (props) => {
  const { clubMembership } = props;

  if (clubMembership.orderDeliveryMethod === 'Ship') {
    return (
      <p className="receipt-shipping-address">
        <span className="receipt-shipping-address-title">Shipping Address</span>
        <span className="receipt-shipping-address-content">
          <br />
          <AddressDisplay address={clubMembership.shipTo} />
        </span>
      </p>
    );
  }
  if (clubMembership.orderDeliveryMethod === 'Pickup') {
    return (
      <p className="receipt-shipping-address">
        <span className="receipt-shipping-address-title">Pick Up At</span>
        <span className="receipt-shipping-address-content">
          <br />
          <AddressOnlyDisplay address={clubMembership.pickupAt} />
        </span>
      </p>
    );
  }
  return null;
};

export default Address;
